<input
	[name]="'input' + name"
	type="date"
	class="form-control"
	[ngModel]="datum"
	[ngClass]="classes()"
	readonly
	inert
/>
